import {
  id,
  Identifiable,
  list,
  Project,
  projectStatus,
  Zone,
  ZoneProjectsRetrievalFilter,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    projects: LinkedProject[];
  };
};

function getZoneProjects(httpClient: HttpClient, linker: Linker) {
  return (zone: Identifiable<Zone>, filter: ZoneProjectsRetrievalFilter) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/search/rsql?query=zone.uuid=='${zone.uuid}'&projection=indicatorsSynthesis&page=${filter.start}&size=${filter.limit}`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => (_embedded ? _embedded.projects : []))
      .then((projects) =>
        projects.map((project) => ({
          ...project,
          zone,
          rootList: { ...list, ...project.activityRoot },
          isTemplate: project.isTemplate || project.template,
          tags: project.tags.map((tag) =>
            typeof tag === "string" ? { name: tag } : tag,
          ),
          status: project.status
            ? project.status
            : { ...projectStatus, uuid: id },
        })),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getZoneProjects };
